import api from '../libs/api'
import { getP } from 'redux-polyglot'

export const FETCH_PAGES_REQUEST = 'PAGES/FETCH_PAGES_REQUEST'
export const FETCH_PAGES_SUCCESS = 'PAGES/FETCH_PAGES_SUCCESS'
export const FETCH_PAGES_FAILURE = 'PAGES/FETCH_PAGES_FAILURE'

export const fetchPagesRequest = () => ({
  type: FETCH_PAGES_REQUEST,
})
export const fetchPagesSuccess = pages => {
  return {
    type: FETCH_PAGES_SUCCESS,
    payload: {
      pages,
    },
  }
}
export const fetchPagesFailure = error => ({
  type: FETCH_PAGES_FAILURE,
  payload: error instanceof Error ? error : new Error(error),
  error: true,
})

export const loadPages = () => (dispatch, getState) => {
  dispatch(fetchPagesRequest())

  return api
    .getPages()
    .then(res => res.json())
    .then(
      response => {
        if (response.status === 200) {
          return dispatch(fetchPagesSuccess(response.pages))
        } else {
          return dispatch(fetchPagesFailure(response.reason))
        }
      },
      () =>
        dispatch(
          fetchPagesFailure(
            getP(getState()).t('support_app.error_loading_page', {
              _: 'An error occurred while retrieving this page',
            })
          )
        )
    )
}
export const DISMISS_ERROR = 'PAGES/DISMISS_ERROR'
export const dismissError = () => ({
  type: DISMISS_ERROR,
})
